<db-dialog-wrapper class="db-ssl-failed-dialog" [dialog]="this" [width]="'942'" [height]="'100%'">
  <div class="ssl-failed-dialog" dbCustomScrollbar>
    <div class="db-ssl-failed-title">{{ 'text_sslFailed.title' | dbText}}</div>
    <div class="db-ssl-failed-desc">{{ 'text_sslFailed.desc' | dbText}}</div>
    <div class="db-step" *ngFor="let step of steps">
      <div class="db-step-title">{{step.title}}</div>
      <div class="db-step-desc">{{step.desc}}</div>
      <img class="db-step-img" src="{{step.img}}"/>
    </div>
    <a class="db-button db-button_info" (click)="close()"><span>GOT IT!</span></a>
  </div>
</db-dialog-wrapper>
